import { render, staticRenderFns } from "./external.vue?vue&type=template&id=880428a2&scoped=true&"
import script from "./external.vue?vue&type=script&lang=js&"
export * from "./external.vue?vue&type=script&lang=js&"
import style0 from "./external.vue?vue&type=style&index=0&id=880428a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880428a2",
  null
  
)

export default component.exports